import type { Dispatch, SetStateAction } from 'react';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogBody,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/dialog';

interface MeetingAttendanceIncompleteAlertProps {
  open: boolean;
  onOpenChange: Dispatch<SetStateAction<boolean>>;
  /** How many participants are still unmarked. */
  unmarkedCount: number;
  /** Marks every unmarked participant present and saves. */
  onMarkRestPresent: () => void;
}

export default function MeetingAttendanceIncompleteAlert(meetingAttendanceIncompleteAlertProps: MeetingAttendanceIncompleteAlertProps) {
  const { open, onOpenChange, unmarkedCount, onMarkRestPresent } = meetingAttendanceIncompleteAlertProps;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className={'sm:max-w-md'}>
        <AlertDialogBody>
          <AlertDialogHeader>
            <AlertDialogTitle>Uzupełnij listę obecności</AlertDialogTitle>
          </AlertDialogHeader>
          <div className={'p-4'}>
            <AlertDialogDescription className={'text-text-secondary'}>
              Każdy uczestnik musi mieć oznaczoną obecność lub nieobecność. Liczba nieoznaczonych uczestników: {unmarkedCount}.
            </AlertDialogDescription>
          </div>
        </AlertDialogBody>
        <AlertDialogFooter>
          <AlertDialogCancel>Wróć do listy</AlertDialogCancel>
          <AlertDialogAction onClick={onMarkRestPresent}>Oznacz jako obecnych i zapisz</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
